export interface VoucherInfo {
	number: number;
	value: number;
	expires: Date;
}

export enum LoyaltyCardsType {
	IndividualCard = 'IndividualCard',
	CorporateCard = 'CorporateCard'
}

export interface LoyaltyCardTypes {
	key: LoyaltyCardsType;
	value: string;
}

export interface TravellerCardValues {
	travellers: Array<{
		loyaltyCardType: LoyaltyCardsType;
		loyaltyCardNumber: string;
	}>;
}
